module.exports = __webpack_public_path__ + "img/mission@2x.8b41e3e.webp";